import { useTranslator } from '../I18n/useTranslator';

const withLoading = (WrappedComponent, Placeholder) => {
  return function WithLoading(props) {
    const { t } = useTranslator();
    if (!props.loading) {
      return <WrappedComponent {...props} />;
    }

    return (
      <div aria-label={t('loading/message')} aria-busy="true">
        <Placeholder {...props} />
      </div>
    );
  };
};

export default withLoading;
